// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__y1LEP","head":"Table_head__1fbyW","col":"Table_col__3i1DE"};